'use strict';

var React = require('react');
var Link = require('react-router').Link;
var withRouter = require('react-router').withRouter;
var ClientSearchStore = require('../stores/ClientSearchStore').default;
var ClientSearchActions = require('../actions/ClientSearchActions');
var Constants = require('../constants/SelectCustomerConstants');
var ApplicationConstants = require('../constants/ApplicationConstants');
var TextInput = require('./Common/TextInput.jsx');
var Transitions = require('../core/Transitions').default;
var InlineMessage = require('./Common/InlineMessage.jsx');
var Spinner = require('./Common/Spinner.jsx');
var RouteConstants = require('../constants/RouteConstants');
import SlidingSessionNotification from './SlidingSessionNotification.jsx';
import OmnitureTracking from '../utils/OmnitureTracking.js';

function getState() {
    return {
        searchValue: ClientSearchStore.getSearchValue(),
        errorList: ClientSearchStore.getErrorList(),
        canSearch: ClientSearchStore.getCanSearch(),
        searchResult: ClientSearchStore.getSearchResult(),
        isLoading: ClientSearchStore.getIsLoading()
    };
}

const ClientSearch = React.createClass({
    getInitialState() {
        return getState();
    },

    componentDidMount() {
        ClientSearchStore.addChangeListener(this._onChange);
        OmnitureTracking.getTrackingEnabled();
    },

    componentWillUnmount() {
        ClientSearchStore.removeChangeListener(this._onChange);
    },

    componentWillUpdate(nextProps, nextState) {
        if (nextState.searchResult === Constants.SearchResult.FOUND) {
            Transitions.forwardFromClientSearch(this.props.router);
        }

        if (nextState.canSearch) {
            const query = { searchValue: this.state.searchValue };
            ClientSearchActions.searchClient(query);
        }
    },

    _onChange() {
        this.setState(getState());
    },

    _onSearch() {
        ClientSearchActions.validateClientSearch();
    },

    _onSearchValueChange(event) {
        ClientSearchActions.updateClientSearch(event.target.value);
    },

    _onGoBack() {
        ClientSearchActions.clearClientSearch();
    },

    _renderNotFound() {
        return (
            this.state.searchResult === Constants.SearchResult.NOT_FOUND ?
                <div className="row">
                    <div className="col-md-8 col-md-offset-2 client-search-message">
                        <InlineMessage key="client-search-message-key"
                            id="client-search-message-id"
                            type="info"
                            message="<h4>No search results were found</h4>" />
                        <p>Your client details do not match our records. Please try again or <Link to={RouteConstants.Root} onClick={this._onGoBack}>go back</Link> to select a different client type </p>
                    </div>
                </div >
                : null
        );
    },

    _renderSearch() {
        var field = Constants.ClientSearch;
        return (
            <div>
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <TextInput id={field.id}
                            value={this.state.searchValue}
                            placeholder={field.placeholder}
                            className="form-text"
                            onBlur={this._onSearchValueChange}
                            model={field.model}
                            errorList={this.state.errorList} />
                        <p></p>
                        <p><a className="btn btn-default btn-block btn-lg" onClick={this._onSearch}>Search</a></p>
                    </div>
                </div>
                { this._renderNotFound() }
            </div>);
    },

    _renderSpinner() {
        return (
            <div className="row">
                <div className="col-md-2 col-md-offset-5">
                    <Spinner size={ApplicationConstants.SpinnerSizes.Three} />
                </div>
            </div>
        );
    },

    render() {
        return (
            <div className="start">
                <div className="container">
                    <SlidingSessionNotification />
                    <h2>Client search</h2>
                    { this.state.isLoading ? this._renderSpinner() : this._renderSearch() }
                </div>
            </div>
        );
    }
});

module.exports = withRouter(ClientSearch);


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ClientSearch.jsx